import React from 'react';
import {Block, Title, Icon, Loader} from '../../../components/components'
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import useCustomTable from "../../../components/tables/useCustomTable";
import Table from "../../../components/tables/Table";
import {TableSearchRow} from "../../../components/tables/TableSearch";
import {COLORS} from "../../../components/theme";
import Pagination from "../../../components/tables/Pagination";
import { useGetStreamsQuery } from '../../../api/streamApiSlice';

export default function StreamsList(props) {
	const { t } = useTranslation();
  const history = useHistory();
  const {
    data: streams = [],
    isSuccess,
    isError,
    refetch
  } = useGetStreamsQuery()
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }

  const columns = [{
      Header: 'Stream',
      accessor: 'stream',
      disableSortBy: true
    },{
      Header: 'Key',
      accessor: 'key'
    },{
    	Header: 'Data type',
    	accessor: 'data_type',
      format: 'badge',
      formatOptions: {color: COLORS.lightGrey}
  	},{
    	Header: 'Created at',
    	accessor: 'created_at',
      format: 'date'
  	}
  ]

  const newStream = () => history.push(`/streams/new`)

  const showStream = (rowData) => history.push(`/streams/${rowData.key}`)

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })

	return (
    <>
			<Title main={t("menu.streams")} includeBackButton={false}>
        <Button variant='primary' onClick={newStream}>
          <Icon icon='plus' text={t("stream.new")} />
        </Button>
      </Title>
      <TableSearchRow {...tableSearchProps}/>
      <Block className="mb-0">
        <Loader {...loaderProps} >
          <Table data={streams} columns={columns} onRowClick={showStream} {...tableProps}/>
        </Loader>
      </Block>
      <Pagination {...paginationProps}/>
		</>
	)
}
